import React from 'react'
import PropTypes from 'prop-types'
import noop from 'lodash/noop'
import { connect } from 'react-redux'
import { QRCodeSVG } from 'qrcode.react'
// import SingEvent from '../../assets/img/sing-event.png'
import Clinet from '../../assets/img/clinet.png'
import Vs from '../../assets/img/vs.png'
import Calendar from '../../assets/img/calendar.png'
import { EMPTY_OBJECT, EVENT_TYPES } from '../../constants/globalConstants'
import {
  dateFormatter,
  formatAMPM,
  formatDateDays,
  //getEventImageById,
  getEventType,
  getImage,
} from '../../utils/helper'

function SixPackTicket(props) {
 // const { eventId, eventType, paymentResponse, eventDetails } = props
 const {eventType, paymentResponse } = props
  const eventArray = paymentResponse?.mapco_qrcode.length > 0 ? paymentResponse?.mapco_qrcode[0]?.event_category?.event_category_event.map((item) => item.event ? item.event : []) : []
  const filteredArray = eventArray.length > 0 ? eventArray.filter(({slug}, index, a) => a.findIndex(e => e.slug === slug) === index): []
  return paymentResponse?.mapco_qrcode?.map((qrcodeData, i) => {
    {
      return (
        <div className="row justify-content-center" key={i}>
          <div className="col-12 col-md-10">
            <div className="card  border-danger shadow mb-3">
              <div className="card-body p-4">
                <div className="row g-5">
                  <div className="col-sm-3 d-none d-sm-block col-12">
                    <div className='centerImage img-thumbnail shadow'>
                       <img
                     
					src={getImage(paymentResponse?.rates)}
                      //src={getEventImageById(eventId)}
                    />
                    </div>
                   
                  </div>
                  <div className="col">
                    <div className="row g-2 align-items-center">
                      <div className="col six_packLogo">
                        <img src={Clinet} width="100px" className="img-fluid" />
                        {'  '}
						<span className='six_packLogo_description'>Rochester Americans</span>
                        <p className="nowrap"></p>
                      </div>
                      <div className="col  text-center">
                        <img
                          src={Vs}
                          width="65px"
                          height="65px"
                          className="img-fluid"
                        />
                      </div>
                    </div>
                    <div className=" border overflow-auto rounded ticketCardHeight">
                    <div className="row  g-0">

                      {
                      
                      filteredArray.length > 0 ? filteredArray.map(
                        (eventData, i) => {
                          if(eventData != ''){
                            return (
                              <div key={i} className="col-4 col-sm-2  p-2 m-0 six_packLogo border-end border-bottom">
                                <img src={getImage(eventData)}
                                //   src={
                                //     process.env.PUBLIC_URL +
                                //     '/game-icons/' +
                                //     eventData?.slug?.replace(/ /g, '') +
                                //     '.png'
                                //   }
                                  width="60px"
                                  className="mx-auto"
                                /><small className='six_packLogo_description'>{eventData?.slug}</small>
                              </div>
                            )
                          }
                        }
                      ) : 'No QR code found'}
                    </div>
                    </div>
                    <div className="border rounded text-center mt-2 p-3">
                      <img src={Calendar} width="35" />{' '}
                      {dateFormatter(
                        paymentResponse?.start_timestamp,
                        'MMMM DD, YYYY'
                      )}
                          ,{formatDateDays(paymentResponse?.start_timestamp)}
                         &nbsp;&nbsp;<br className='d-block d-sm-none'/> {formatAMPM(paymentResponse?.start_timestamp)} 
                         {paymentResponse?.parking_time_message && <small className='d-block lh-sm'>{paymentResponse?.parking_time_message}</small>}
                         {/* qrcodeData?.event_category?.event_category_event[0]?.event?.start_time */}
                    </div>
                    <div className="row">
                      {/* <div className="col">
												<small>Total 2 Entires Allowed</small>
											</div>
											<div className="col text-end">
												<small>
													{' '}
													<Link to={URL.HOME}>
														{' '}
														Click here to add to calendar{' '}
													</Link>
												</small>
											</div> */}
                    </div>
                    <br />
                    <h3 className=" mt-3 fw-bold pt-2 text-center">
                      {/* {getEventType(eventType)} */}
                      {eventType == EVENT_TYPES?.EVENT
                        ? getEventType(eventType)
                        : paymentResponse?.rates?.description}
                    </h3>
                  </div>
                  <div className="col-sm-3 d-block d-sm-none col-12">
                  <div className='centerImage img-thumbnail shadow'>
                  <img
                     
                     src={getImage(paymentResponse?.rates)}
                                 //src={getEventImageById(eventId)}
                               />
                    </div>
                  </div>

                  <div className="col-sm-3 ps-sm-0 col-12">
                    <div className="p-2 bg-danger rounded">
                      <div className="bg-white p-2">
                        <div id="responsive-canvas">
                          {qrcodeData && (
                            <QRCodeSVG
                              value={qrcodeData?.qrcode}
                              width="100%"
                              height="100%"
                              // size={180}
                            />
                          )}
                          <span className="d-flex justify-content-center mt-2">
                            <b>{qrcodeData?.qrcode}</b>
                          </span>
                        </div>
                      </div>
                      <div className="mt-1 d-flex align-items-center justify-content-center text-white">
                        <p className="mt-2">Total Paid : </p>
                        <h3 className="mt-2">
                          ${paymentResponse.total}
                        </h3>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )
    }
  })
}
SixPackTicket.propTypes = {
  dispatch: PropTypes.func,
  data: PropTypes.object,
  eventId: PropTypes.string,
  eventType: PropTypes.string,
  paymentResponse: PropTypes.object,
  eventDetails:PropTypes.object
}

SixPackTicket.defaulProps = {
  dispatch: noop,
  data: EMPTY_OBJECT,
  eventId: undefined,
  eventType: undefined,
  paymentResponse: EMPTY_OBJECT,
  eventDetails: EMPTY_OBJECT,
}

function mapStateToProps({ peymentReducer }) {
  return {
    data: peymentReducer,
  }
}
export default connect(mapStateToProps)(SixPackTicket)
